import { useEffect, useState } from 'react'
import { cn } from '@/lib/cn'
import { agentActiveAt } from '../telemetry/core'
import { useTelemetry } from '../telemetry/useTelemetry'

const MAX_SERVICES = 8

function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs)
    return () => window.clearInterval(id)
  }, [intervalMs])
  return now
}

/**
 * The breathing pipeline topology (R5, Home consumer): core node +
 * fleet services from telemetry, idling with slow pulses; the core
 * edge lights up while the agent is active. Mounted as a teaser under
 * the Home interstitial now; U7 gives it its bento cell.
 */
export function HomeTopology() {
  const t = useTelemetry()
  const now = useNow(2000)
  const active = agentActiveAt(t, now)
  const services = t.services.slice(0, MAX_SERVICES)

  return (
    <div className="fm-topology fui-panel" aria-label="Live system topology">
      <div className="fm-topology-head">
        <span className="fui-eyebrow">
          <span className={cn('fui-eyebrow-dot', active && 'cyan')} aria-hidden="true" />
          system topology
        </span>
        <span className="fui-label">
          {t.health ? `${t.health.up}/${t.health.total} up` : 'awaiting status…'}
        </span>
      </div>
      <div className="fm-topology-band">
        <div className={cn('fm-core', t.feed === 'live' && 'alive', active && 'busy')}>
          <span className="fm-core-ring" aria-hidden="true" />
          <span className="fm-node-label">tovieos core</span>
          <span className="fm-node-sub">{active ? 'agent active' : t.feed === 'live' ? 'listening' : 'connecting'}</span>
        </div>
        <div className={cn('fm-trunk', active && 'busy')} aria-hidden="true">
          <span className="fm-trunk-beam" />
        </div>
        <div className="fm-services">
          {services.length === 0 ? (
            <span className="fm-node-sub">-- no services reported yet</span>
          ) : (
            services.map((s) => (
              <div key={s.id} className={cn('fm-service', s.status)} title={s.name}>
                <span className="fm-node-dot" aria-hidden="true" />
                <span className="fm-node-label">{s.name}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
